module.exports = function getResource(label, vars = []) {
    let resources = {
        viewShippedBasket: `${vars[0] ? '' : 'View your '}Get It Shipped basket`,
        viewPickupBasket: `${vars[0] ? '' : 'View your '}Buy Online & Pick Up basket`
    };

    return resources[label];
};
